import React, { useState, useMemo, useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import useHttp from '../../../hooks/http';
import { GetTypes } from './GetTypes';
import AUX from '../../../hoc/AU-X/AU-X';
import SimpleFrame from '../../../Components/UI/SimpleFrame/SimpleFrame';
import './Get.scss';

const Items = [
  { title: 'اضافه موردی', url: 'AddInvidualData' },
  { title: 'آپلود اطلاعات', url: 'UploadData' },
  // { title: 'دریافت اطلاعات', url: 'chigao' },
  { title: 'لیست', url: 'GetData' },
];

const specials = [
  {
    self: 'Dam',
    childs: [
      { url: 'DamHumanUsage', title: 'سد' },
      { url: 'DamHumanVolume', title: 'حجم' },
    ],
  },
  {
    self: 'Lake',
    childs: [
      { url: 'LakeLevel', title: 'تراز' },
      { url: 'LakeEvaporation', title: 'تبخیر' },
    ],
  },
];

const Get = () => {
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const [displayData, setDisplayData] = useState();
  const [allIds, setAllIds] = useState();

  const { type } = useParams();
  const thisPageData = useMemo(() => ({ ...GetTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);
  const location = useLocation();

  useEffect(() => {
    sendRequest(thisPageData.url, 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, thisPageData, token]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      const allDataNeeded = [];
      const neededIds = [];
      let temp;

      data.forEach((element) => {
        neededIds.push({ gainValue: element.id, value: element.name });
        temp = {};

        thisPageData.parameters.forEach((param) => {
          temp[param] = element[param];
        });
        allDataNeeded.push(temp);
      });

      if (allDataNeeded[0] && allDataNeeded[0].lat) {
        allDataNeeded.forEach((e) => {
          if (e.lat && !isNaN(e.lat)) {
            e.lat = e.lat.toFixed(5);
          }
          if (e.lng && !isNaN(e.lng)) {
            e.lng = e.lng.toFixed(5);
          }
        });
      }

      setDisplayData(() => (allDataNeeded.length === 0 ? 'no data' : allDataNeeded));
      setAllIds(() => ({ page: type, options: neededIds }));

      clear();
    }
  }, [error, isLoading, data, clear, setDisplayData, thisPageData, type]);

  const beforeGet = useMemo(() => {
    let specialIndex = -1;
    specials.forEach((element, i) => {
      if (type === element.self) {
        specialIndex = i;
      }
    });

    if (specialIndex !== -1) {
      return (
        <AUX>
          <ul
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', margin: '5px 0' }}
          >
            {Items.map((item) => (
              <li style={{ width: '100%' }} key={item.url}>
                <div>{item.title}</div>
              </li>
            ))}
          </ul>
          {specials[specialIndex].childs.map((item, i) => (
            <div className='grid-3' style={{ margin: '5px 0', padding: '0' }} key={item.url}>
              {Items.map(
                (upload, index) =>
                  index < 2 && (
                    <NavLink
                      key={upload.url}
                      className={location.pathname.indexOf(item.url) === -1 ? '' : 'activeItem'}
                      to={{
                        pathname: `/${upload.url}/${item.url}`,
                        state: allIds,
                      }}
                    >
                      مربوط به {item.title}
                    </NavLink>
                  )
              )}

              {i === 0 && (
                <NavLink
                  className={location.pathname.indexOf('GetData') === -1 ? '' : 'activeItem'}
                  to={{
                    pathname: `/GetData/${specials[specialIndex].self}`,
                    state: allIds,
                  }}
                >
                  لیست
                </NavLink>
              )}
            </div>
          ))}
        </AUX>
      );
    } else {
      return (
        <div className='grid-3'>
          {Items.map((item) => (
            <NavLink
              className={location.pathname.indexOf(item.url) === -1 ? '' : 'activeItem'}
              to={{
                pathname: `/${item.url}/${type}`,
                state: allIds,
              }}
              key={item.url}
            >
              {item.title}
            </NavLink>
          ))}
        </div>
      );
    }
  }, [type, allIds, location]);

  return (
    <SimpleFrame goBack='/' style={{ width: '80%' }}>
      {beforeGet}
      {displayData && displayData !== 'no data' && (
        <AUX>
          <h2>لیست اطلاعات {thisPageData.title}</h2>

          <ul className='displayData'>
            {Object.keys(displayData[0]).map((v) => {
              return (
                <li key={v}>
                  <div>{v}</div>
                </li>
              );
            })}
          </ul>
          <div className='line' style={{ margin: '2rem -1rem' }}>
            <div></div>
          </div>
          {displayData.map((display) => {
            const keys = Object.keys(display);

            return (
              <ul className='displayData' key={display.id}>
                {keys.map((v) => (
                  <li key={v}>
                    <div>{display[v]}</div>
                  </li>
                ))}
              </ul>
            );
          })}
        </AUX>
      )}
      {displayData === 'no data' && (
        <p style={{ width: '100%', textAlign: 'center', marginTop: '5rem' }}>این صفحه فعلا دیتایی ندارد</p>
      )}
    </SimpleFrame>
  );
};

export default Get;
